<template>
    <div class="operation">
        <!--  -->
        <!-- <div class="head padd20 borbut20">
            <div class="topSearchSou">
                <div class="searchdan">
                    <div class="title">用户手机号：</div>
                    <el-input v-model="input" placeholder="请输入用户手机号" oninput="value=value.replace(/[^\d\.]/g,'')"></el-input>
                </div>
                <div class="searchdan time">
                    <div class="title">开始日期：</div>
                    <el-date-picker v-model="pickerTime" @change="onPicker" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
                </div>
                <el-button type="primary" icon="el-icon-search" @click="sousuo()">搜索</el-button>
                <el-button class="Shuarefresh" @click="$router.go(0)" icon='el-icon-refresh-right'>重置数据</el-button>
            </div>
        </div> -->
        <!--  -->
        <div class="tab padd20">
            <div class="duoshao">
                <div class="title">媒体文件转文字列表</div>
                <!-- <el-button type="primary" id="Operate" @click="addyunying($event)" class="yinyinga">新增运营官</el-button> -->
                <div class="lvtotal">总条数：{{lvtotal}} 条</div>
            </div>
            <el-table ref="filterTable" :data="tableData" style="width: 100%">
                <!-- <el-table-column prop="id" label="头像">
                    <template slot-scope="scope">
                        <img :src="scope.row.server_wechat.wechat_head" alt="">
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="server_wechat.wechat_name" label="昵称">
                    <template slot-scope="scope">
                        {{ Base64.decode(scope.row.server_wechat.wechat_name)}}
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="wechat_sex" label="性别">
                    <template slot-scope="scope">
                        {{scope.row.server_wechat.wechat_sex == 1 ? '男' : '女'}}
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="account" label="手机号">
                    <template slot-scope="scope">
                        <span>{{scope.row.account ? scope.row.account : '- -'}}</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="updated_at" label="地区">
                    <template slot-scope="scope">
                        <span v-if="scope.row.server_wechat.wechat_country"> {{scope.row.server_wechat.wechat_country}} {{scope.row.server_wechat.wechat_province}} {{scope.row.server_wechat.wechat_city}} </span>
                        <span v-else>- -</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="file.file_name" label="文件名"></el-table-column>
                <el-table-column prop="type" label="识别状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type == 1" style="color:#409EFF">识别中</div>
                        <div v-else-if="scope.row.type == 2" style="color:#67C23A">识别完成</div>
                        <div v-else style="color:red">识别失败</div>
                    </template>
                </el-table-column>
                <el-table-column prop="text" label="识别结果">
                    <template slot-scope="scope">
                        <el-popover placement="bottom" width="500" trigger="click" :content="scope.row.text">
                            <span class="copyInfo" slot="reference" v-if="scope.row.text!=null">{{scope.row.text}}</span>
                            <span slot="reference" v-if="scope.row.text==''||scope.row.text==null">--</span>
                        </el-popover>
                    </template>

                </el-table-column>
                <el-table-column prop="created_at" label="上传时间"></el-table-column>
                <!-- <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.server_wechat.subscribe == 1" class="red"> <i class="iconfont icon-biaoqiankuozhan_guanzhu-344 red"></i> 关注中</span>
                        <span v-if="scope.row.server_wechat.subscribe != 1" class=""><i class="iconfont icon-biaoqiankuozhan_guanzhu-344"></i> 取消关注</span>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- 分页 -->
            <div class="fenye">
                <el-pagination class="lv-page" :page-size="per_page" :pager-count="11" @current-change="DialogCurrentChange" background layout="prev, pager, next" :total="lvtotal" hide-on-single-page :current-page.sync="paramPage"></el-pagination>
            </div>
        </div>

        <!-- 弹窗 -->
        <!-- <div>
            <Operate ref="Operate" :msg="activeName" @yunying="yunying" v-if="activeName == 'Operate'"></Operate>
            <CompileRun ref="CompileRun" :id="operating_id" :msg="activeName" @bianji="bianji" v-if="activeName == 'CompileRun'"></CompileRun>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            paramData: {}, //表格参数
            input: "", //搜索内容
            pickerTime: null, //开始日期结束日期
            operating_id: "", //运营官id
            tableData: [], //显示运营列表
            per_page: 10, //一页多少条
            lvtotal: null, //共几条数据
            paramPage: 1, //表格当前第几页
            page: "1",
            activeName: "",
        };
    },
    mounted() {
        this.ongetMediaToTextList();
    },
    components: {},
    methods: {
        //日期选择触发
        onPicker() {
            // console.log(this.pickerTime);
        },
        // 获取运营官列表
        ongetMediaToTextList() {
            var param = this.paramData;
            param.pre_page = this.pre_page;
            this.$service.get(this.$api.getMediaToTextList, param, (res) => {
                if (res.code == "200") {
                    this.tableData = res.data.data;
                    this.lvtotal = res.data.count;
                }
            });
        },
        //搜索运营官
        sousuo() {
            this.paramData = {
                account: this.input,
                start_created_at: this.pickerTime ? this.pickerTime[0] : "", //开始日期
                end_created_at: this.pickerTime ? this.pickerTime[1] : "", //结束日期
            };
            this.paramPage = 1;
            this.ongetMediaToTextList();
        },
        // 筛选
        filterTag(value, row) {
            return row.tag === value;
        },
        // 编辑
        handleEdit(index, row, e) {
            this.activeName = e.currentTarget.id;
            this.operating_id = row.id;
            // console.log(e.srcElement.id);
            // console.log(index, row);
        },
        // 删除
        handleDelete(index, row) {
            // console.log(index, row);
        },
        // 分页
        DialogCurrentChange(val) {
            this.paramPage = val;
            this.ongetMediaToTextList();
        },
    },
};
</script>

<style lang="scss" scoped>
.operation {
    display: flex;
    flex-direction: column; //垂直显示
    .head {
        display: flex;
        justify-content: center;
    }

    .tab {
        img {
            width: 50px;
            height: 50px;
        }
    }
    .fenye {
        text-align: right;
        margin-top: 25px;
        margin-right: 50px;
    }
    .xzyunying {
        margin-bottom: 20px;
    }
    .ii {
        width: 20px;
        height: 20px;
    }
    .iconfont {
        // color: red;
        // margin-top: 24px;
    }
    .red {
        color: red;
    }
    .copyInfo {
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
<style lang="scss">
.operation {
    .el-input {
        width: 180px;
    }
    .el-step__title {
        margin-left: -5px;
    }

    .el-table__column-filter-trigger i {
        color: #0075f7;
        margin-left: 10px;
    }
    .el-form-item__label {
        text-align: left;
    }
    .el-form-item {
        margin-top: 20px;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
    .dialog-footer {
        display: flex;
        justify-content: center;
    }
    .el-dialog__header {
        padding: 20px 20px;
    }
}
</style>